<template>
  <div class="card p-shadow-app" :style="{ position: 'relative' }">
    <div class="p-fluid p-grid">
      <div class="p-col-12 p-md-1" style="margin: auto">
        <h4>Suporte</h4>
      </div>
      <div class="p-col-12 p-md-11">
        <Menubar :model="menuBar" />
      </div>
    </div>
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <ConfirmDialog />
    <Dialog
      id="'dialog-hours'"
      :visible.sync="showTaskForm"
      :style="{ width: $isMobile() ? '100vw' : '60vw' }"
      :modal="true"
      :header="
        this.userTask != null && this.userTask.action === 'update'
          ? 'Atualizar Suporte'
          : this.userTask != null && this.userTask.action === 'view'
          ? 'Ver Suporte'
          : 'Criar Suporte'
      "
    >
      <SupportForm
        :task="userTask"
        :interventionTypes="interventionTypes"
        :myUsers="myUsers"
        v-on:submitTaskForm="taskFormSubmited"
        v-on:cancelTaskForm="taskFormCanceled"
      />
    </Dialog>

    <Dialog
      id="'calendarGoTo'"
      :visible.sync="calendarGoTo"
      :style="{ width: $isMobile() ? '100vw' : '35vw' }"
      :modal="true"
      :header="'Ir para dia'"
    >
      <div class="p-col-12 p-text-center">
        <v-calendar @dayclick="goDate" locale="pt" />
      </div>
    </Dialog>

    <Loading :active.sync="isLoading" :is-full-page="false"></Loading>
    <Loading :active.sync="firstload" :is-full-page="false"></Loading>
    <Loading :active.sync="refreshLoad" :is-full-page="false"></Loading>

    <div class="p-fluid p-grid p-mt-2">
      <div
        class="p-col-12 p-md-3"
        v-for="node in nodes"
        :key="node.key"
        v-show="menuConfig.technicians == true"
      >
        <Tree
          selectionMode="checkbox"
          :value="node"
          :selectionKeys.sync="selectedNodes"
          @node-select="onNodeSelect"
          @node-unselect="onNodeUnselect"
        >
          <template #default="slotProps">
            <div
              class="tree-border-color"
              :style="{
                'border-color':
                  slotProps.node.children != undefined
                    ? slotProps.node.children[0].officeColor
                    : slotProps.node.userColor,
              }"
            >
              {{ slotProps.node.label }}
            </div>
          </template>
        </Tree>
      </div>
      <div class="p-col-12 p-mb-3" v-show="menuConfig.colors == true">
        <b>Cor das Intervenções</b>
        <div class="p-fluid p-grid p-mt-2 p-ml-1">
          <div class="p-d-flex p-ai-center p-mr-4 p-mt-1">
            <InputSwitch
              v-model="taskColor.office"
              class="p-mr-2"
              @input="taskColorChange('office')"
            />
            <label>Escritório</label>
          </div>
          <div class="p-d-flex p-ai-center p-mr-4 p-mt-1">
            <InputSwitch
              v-model="taskColor.task"
              class="p-mr-2"
              @input="taskColorChange('task')"
            />
            <label> Tipo </label>
          </div>
          <div class="p-d-flex p-ai-center p-mr-4 p-mt-1">
            <InputSwitch
              v-model="taskColor.user"
              class="p-mr-2"
              @input="taskColorChange('user')"
            />
            <label>Colaborador</label>
          </div>
        </div>
      </div>
      <div class="p-col-12 p-mb-3" v-show="menuConfig.whatToSee == true">
        <b>Ver</b>
        <div class="p-fluid p-grid p-mt-2 p-ml-1">
          <div class="p-d-flex p-ai-center p-mr-4 p-mt-1">
            <InputSwitch
              v-model="taskTypes.all"
              class="p-mr-2"
              @input="taskTypeChange('all')"
            />
            <label>Tudo</label>
          </div>
          <div class="p-d-flex p-ai-center p-mr-4 p-mt-1">
            <InputSwitch
              v-model="taskTypes.interventions"
              class="p-mr-2"
              @input="taskTypeChange('interventions')"
            />
            <label> Intervenções </label>
          </div>
          <div class="p-d-flex p-ai-center p-mr-4 p-mt-1">
            <InputSwitch
              v-model="taskTypes.schedules"
              class="p-mr-2"
              @input="taskTypeChange('schedules')"
            />
            <label>Reservas</label>
          </div>
          <div class="p-d-flex p-ai-center p-mr-4 p-mt-1">
            <InputSwitch
              v-model="taskTypes.unavailable"
              class="p-mr-2"
              @input="taskTypeChange('unavailable')"
            />
            <label>Indisponibilidades</label>
          </div>
        </div>
      </div>
    </div>
    <div
      ref="calendarWrapper"
      :class="[
        'calendar-fullscreen-wrapper',
        { fullscreen: isCalendarFullscreen },
      ]"
      :style="calendarWrapperStyle"
    >
      <FullCalendar ref="fullCalendar" :options="calendarOptions">
        <template v-slot:eventContent="arg">
          <EventContent
            :event-arg="arg"
            @delete="deleteTask"
            @clone="cloneTask"
            @update="updateFromForm"
          />
        </template>

        <template v-slot:resourceLabelContent="arg">
          <span
            v-if="arg.view.type == 'resourceTimeGridDay'"
            :style="{ backgroundColor: arg.resource.extendedProps.officeColor }"
            class="resourceLabelContent"
          >
            {{ arg.resource.title }} - {{ arg.resource.extendedProps.office }}
          </span>
          <span
            v-else-if="arg.view.type == 'resourceTimeGridWeek'"
            :style="{ backgroundColor: arg.resource.extendedProps.officeColor }"
            class="resourceLabelContent"
            v-tooltip="arg.resource.title"
          >
            {{ arg.resource.extendedProps.technicianInitials }}
          </span>
          <span v-else>
            {{ arg.resource.title }}
          </span>
        </template>
        <template v-slot:dayHeaderContent="arg">
          <span class="p-md-10 p-text-left">
            {{ arg.text }}
          </span>
          <span class="p-md-2 p-text-right">
            <i class="day-header-status pi pi-lock-open"></i>
          </span>
          <span class="p-md-2 p-text-right">
            <i
              class="day-header-status pi pi-map-marker cursor-grab"
              v-tooltip="'Ver no mapa'"
              v-on:click="goToMap(arg.date)"
            ></i>
          </span>
        </template>
      </FullCalendar>
    </div>
  </div>
</template>

<script>
import chroma from "chroma-js";
import supportForm from "./SupportForm";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";
import EventContent from "../components/support/EventContent.vue";

import ptLocale from "@fullcalendar/core/locales/pt";
import {
  getOnlyDate,
  hexToRGB,
  getOnlyTime,
  isDateBeforeToday,
} from "../helpers/helpers";
import Task from "../models/task";
import taskService from "../services/task.service";
import interventionService from "../services/intervention.service";
import bookingService from "../services/booking.service";
import moment from "moment";
import loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Menubar from "primevue/menubar";

export default {
  name: "Support",
  components: {
    SupportForm: supportForm,
    Loading: loading,
    Menubar,
    EventContent,
  },
  data() {
    return {
      calendarHeight: 600,
      calendarResizeFrame: null,
      isCalendarFullscreen: false,
      taskColor: { office: true, task: false, user: false },
      taskTypes: {
        all: true,
        interventions: false,
        schedules: false,
        unavailable: false,
      },
      userTask: null,
      showTaskForm: false,
      userId: null,
      interventionTypes: [],
      calendarApi: null,
      tasksInCalendar: [],
      myUsers: [],
      calendarOptions: null,
      viewOtherUsers: false,
      calendarGoTo: false,
      isLoading: true,
      nodes: [],
      selectedNodes: {},
      userTasksInCalendar: {},
      firstload: true,
      refreshLoad: false,
      key: 0,
      menuBar: [
        {
          label: "Ver Técnicos",
          icon: "pi pi-fw pi-users",
          command: () => this.menuClick("technicians"),
        },
        {
          label: "Ver Cores",
          icon: "pi pi-fw pi-slack",
          command: () => this.menuClick("colors"),
        },
        {
          label: "Ver Tipo de Intervenções",
          icon: "pi pi-fw pi-list",
          command: () => this.menuClick("whatToSee"),
        },
        {
          label: "Ver Tudo",
          icon: "pi pi-fw pi-bars",
          command: () => this.menuClick("seeAll"),
        },
        {
          label: "Esconder Tudo",
          icon: "pi pi-fw pi-eye-slash",
          command: () => this.menuClick("hideAll"),
        },
      ],
      menuConfig: {
        technicians: false,
        colors: false,
        whatToSee: false,
        seeAll: false,
        hideAll: false,
      },
    };
  },
  computed: {
    calendarWrapperStyle() {
      if (this.isCalendarFullscreen) {
        return {};
      }

      return {
        height: `${this.calendarHeight}px`,
      };
    },
    loggedUser() {
      return this.$store.state.auth.user;
    },
  },
  beforeCreate() {},
  async created() {
    this.userId = this.$store.state.auth.user.id;
    if (localStorage.supportColorsBy !== undefined) {
      this.taskColor = JSON.parse(localStorage.supportColorsBy);
    }
    await this.getInterventionTypes();
  },
  async beforeMount() {
    this.dataToTree();
    await this.generateCalendar();
    let updatateBtn = document.querySelector(".fc-icon-update-btn");
    if (updatateBtn) {
      updatateBtn.className = "pi pi-spinner";
    }
    let fullscreeBtn = document.querySelector(".fc-icon-fullscreen-btn");
    if (fullscreeBtn) {
      fullscreeBtn.className = "pi pi-window-maximize";
    }
  },
  async activated() {
    this.$nextTick(() => {
      if (this.$refs.fullCalendar) {
        this.calendarApi = this.$refs.fullCalendar.getApi();
        this.updateCalendarHeight();
        let currentTime = moment();
        this.calendarApi.scrollToTime({
          days: currentTime.isoWeekday() - 1,
          milliseconds:
            ((currentTime.hours() - 1) * 60 + currentTime.minutes()) * 60000,
        });
      }
    });
  },
  mounted() {
    this.calendarApi = this.$refs.fullCalendar.getApi();
    window.addEventListener("resize", this.scheduleCalendarResize);
    this.updateCalendarHeight();
    let currentTime = moment();
    this.calendarApi.scrollToTime({
      days: currentTime.isoWeekday() - 1,
      milliseconds:
        ((currentTime.hours() - 1) * 60 + currentTime.minutes()) * 60000,
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.scheduleCalendarResize);
    if (this.calendarResizeFrame) {
      window.cancelAnimationFrame(this.calendarResizeFrame);
    }
    document.body.style.overflow = "";
  },
  methods: {
    confirmTaskDuplicatedPat(message, task, patNumber) {
      this.$confirm.require({
        message: message,
        header: `Já existe intervenção para o PAT ${patNumber}, Deseja Continuar?`,
        acceptLabel: "Sim, continuar",
        rejectLabel: "Não, cancelar",
        icon: "pi pi-exclamation-triangle",
        accept: async () => {
          await this.taskFormSubmited(task);
        },
        reject: () => {
          this.$delete(task, "proceed_action");
          this.$toast.add({
            severity: "warn",
            summary: "Cancelado!",
            detail: "Registo de tarefa cancelado",
            life: 3000,
          });
        },
      });
    },
    toggleCalendarFullscreen() {
      this.isCalendarFullscreen = !this.isCalendarFullscreen;
      if (this.isCalendarFullscreen) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
      this.scheduleCalendarResize();
    },
    scheduleCalendarResize() {
      if (this.calendarResizeFrame) {
        window.cancelAnimationFrame(this.calendarResizeFrame);
      }

      this.calendarResizeFrame = window.requestAnimationFrame(() => {
        this.calendarResizeFrame = null;
        this.updateCalendarHeight();
      });
    },
    updateCalendarHeight() {
      this.$nextTick(() => {
        const calendarWrapper = this.$refs.calendarWrapper;
        if (!calendarWrapper) {
          return;
        }

        const wrapperTop = calendarWrapper.getBoundingClientRect().top;
        const bottomSpacing = this.isCalendarFullscreen ? 0 : 24;
        const minHeight = this.$isMobile() ? 360 : 420;

        this.calendarHeight = Math.max(
          window.innerHeight - wrapperTop - bottomSpacing,
          minHeight
        );

        if (this.calendarApi) {
          this.calendarApi.updateSize();
        }
      });
    },
    dataToTree() {
      let hasLocal = false;
      if (localStorage.selectedNodes != undefined) {
        hasLocal = true;
        this.selectedNodes = JSON.parse(localStorage.selectedNodes);
      }
      for (const [office, user] of Object.entries(
        this.$store.state.auth.user.supportUsers
      )) {
        let users = [];
        user.forEach((myUser) => {
          this.myUsers.push({
            id: myUser.id,
            username: myUser.username,
            office: office,
            userColor: myUser.userColor,
            officeColor: myUser.officeColor,
            technicianInitials: myUser.technicianInitials,
          });
          users.push({
            key: myUser.id,
            label: myUser.username,
            data: `${office} Office User`,
            icon: "pi pi-fw pi-user",
            userColor: myUser.userColor,
            officeColor: myUser.officeColor,
            technicianInitials: myUser.technicianInitials,
          });

          if (!hasLocal) {
            this.selectedNodes[myUser.id] = {
              checked: true,
              partialChecked: false,
            };
          }

          this.userTasksInCalendar[myUser.id] = {
            inCalendar:
              this.selectedNodes[myUser.id] != undefined
                ? this.selectedNodes[myUser.id].checked
                : false,
            userId: myUser.id,
            userColor: myUser.userColor,
            officeColor: myUser.officeColor,
            interventionConfirmedColor: myUser.interventionConfirmedColor,
            username: myUser.username,
            userOffice: myUser.office,
            technicianInitials: myUser.technicianInitials,
            tasks: [],
          };
        });
        let tree = {
          key: office,
          label: office,
          data: `office`,
          icon: "pi pi-fw pi-home",
          children: users,
        };
        this.nodes.push({ tree });
        if (!hasLocal) {
          this.selectedNodes[office] = {
            checked: true,
            partialChecked: false,
          };
        }
      }
      if (!hasLocal) {
        localStorage.selectedNodes = JSON.stringify(this.selectedNodes);
      }
    },
    refetchEvents() {
      this.refreshLoad = true;
      this.calendarApi.refetchEvents();
    },
    generateCalendar() {
      const calendarGoTo = () => (this.calendarGoTo = true);

      const changeView = (view) => {
        localStorage.supportInitialView = view;
        this.calendarApi.changeView(view);
        this.calendarApi.refetchEvents();
      };
      const changeDates = (where) => {
        if (where == "prev") {
          this.calendarApi.prev();
        } else if (where == "next") {
          this.calendarApi.next();
        }
      };

      const toogleWeekends = () => {
        if (this.calendarOptions.weekends == false) {
          this.calendarOptions.weekends = true;
          localStorage.supportShowWeekends = true;
        } else {
          this.calendarOptions.weekends = false;
          localStorage.supportShowWeekends = false;
        }
      };

      const toggleCalendarFullscreen = () => {
        return this.toggleCalendarFullscreen();
      };

      const refetchEvents = () => {
        return this.refetchEvents();
      };

      const getResources = () => {
        return this.getResources();
      };
      const stripedDays = (arg) => {
        if (moment(arg.date).isoWeekday() % 2 == 0) {
          return "slotLaneStriped";
        }
      };

      this.calendarOptions = {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          bootstrapPlugin,
          resourceTimelinePlugin,
          resourceTimeGridPlugin,
        ],
        stickyHeaderDates: true,
        schedulerLicenseKey: "CC-Attribution-NonCommercial-NoDerivatives",
        locale: ptLocale,
        allDaySlot: true,
        nowIndicator: true,
        selectable: true,
        firstDay: 1,
        height: "100%",
        weekends: localStorage.supportShowWeekends == "true" ? true : false,
        scrollTime: "09:00",
        slotDuration: "00:15",
        slotLabelInterval: "01:00",
        views: {
          timeGrid: {
            slotLabelFormat: {
              hour: "numeric",
              minute: "2-digit",
              omitZeroMinute: false,
              meridiem: "short",
            },
          },
          timeline: {
            slotLaneClassNames: stripedDays,
            slotLabelFormat: [
              {},
              {
                hour: "numeric",
                minute: "2-digit",
                omitZeroMinute: false,
                meridiem: "short",
              },
            ],
          },
          resourceTimeGridDay: {
            titleFormat: {
              weekday: 'long',
              day: 'numeric',
              month: 'long',
              year: 'numeric'
            }
          },
        },
        datesAboveResources: true,
        initialView: localStorage.supportInitialView
          ? localStorage.supportInitialView
          : this.$isMobile()
          ? "timeGrid"
          : "timeGridWeek",
        resources: getResources,
        resourceGroupField: "office",
        resourceOrder: "office",
        resourceAreaWidth: "15%",
        resourceAreaColumns: [
          {
            headerContent: "Equipa",
          },
        ],
        displayEventTime: true,
        displayEventEnd: true,
        editable: true,
        slotEventOverlap: false,
        customButtons: {
          showCalendar: {
            text: "Ir para",
            click: function () {
              calendarGoTo();
            },
          },
          toogleWeekends: {
            text: "Toggle Fds",
            hint: "Mostrar/Ocultar Fim de Semana",
            click: function () {
              toogleWeekends();
            },
          },
          updateCalendar: {
            icon: "update-btn",
            hint: "Atualizar Tarefas",
            click: function () {
              refetchEvents();
            },
          },
          prev: {
            icon: "chevron-left",
            click: function () {
              changeDates("prev");
            },
          },
          next: {
            icon: "chevron-right",
            click: function () {
              changeDates("next");
            },
          },
          resourceTimelineWeek: {
            text: "Timeline",
            click: function () {
              changeView("resourceTimelineWeek");
            },
          },
          resourceTimeGridWeek: {
            text: "Disponibilidade",
            click: function () {
              changeView("resourceTimeGridWeek");
            },
          },
          resourceTimeGridDay: {
            text: "Dia",
            click: function () {
              changeView("resourceTimeGridDay");
            },
          },
          timeGridWeek: {
            text: "Semana",
            click: function () {
              changeView("timeGridWeek");
            },
          },
          fullscreen: {
            icon: "fullscreen-btn",
            hint: "Ver/Sair Ecrã Inteiro",
            click: function () {
              toggleCalendarFullscreen();
            },
          },
        },
        buttonText: {
          // resourceTimeGridDay: "Dia",
          // resourceTimeGridWeek: "Disponibilidade",
        },
        headerToolbar: {
          left: "prev,today,showCalendar,next",
          center: "title",
          right:
            "resourceTimelineWeek,resourceTimeGridWeek,resourceTimeGridDay,timeGridWeek,toogleWeekends,updateCalendar,fullscreen",
        },
      };
      const startLoading = () => {
        this.refreshLoad = true;
        this.isLoading = true;
      };
      const stopLoading = () => {
        this.refreshLoad = false;
        this.isLoading = false;
      };
      const getMultipleTasks = (dateStart, dateEnd, userIds) =>
        this.getMultipleUsersTasks(dateStart, dateEnd, userIds);
      const removeAllTasks = () => this.removeAllTasks();
      const userInCalendar = this.userTasksInCalendar;
      this.calendarOptions.events = [];
      this.calendarOptions.events = function (info, successCallback) {
        startLoading();
        removeAllTasks();

        let userIds = [];
        Object.entries(userInCalendar).forEach(([userId, userInfo]) => {
          if (userInfo.inCalendar) {
            userIds.push(parseInt(userId));
          }
        });

        if (userIds.length === 0) {
          successCallback([]);
          stopLoading();
          return;
        }

        getMultipleTasks(
          getOnlyDate(info.start),
          getOnlyDate(info.end),
          userIds
        )
          .then((tasks) => successCallback(tasks))
          .finally(() => stopLoading());
      };

      const updateTask = (taskId, taskData) =>
        this.updateTask(taskId, taskData);

      const updateBooking = (bookingId, bookingData) =>
        this.updateBooking(bookingId, bookingData);

      this.calendarOptions.eventResize = function (info) {
        if (info.event.extendedProps.taskInfo.isBooking) {
          let bookingInfo = {
            start: getOnlyTime(info.event.start),
            end: getOnlyTime(info.event.end),
          };

          info.event.extendedProps.taskInfo.start = bookingInfo.start;
          info.event.extendedProps.taskInfo.end = bookingInfo.end;
          updateBooking(info.event.extendedProps.taskInfo.id, bookingInfo);
        } else {
          let taskInfo = {
            type: info.event.extendedProps.taskInfo.typeId,
            pat_number: parseInt(info.event.extendedProps.taskInfo.pat_number),
            start: `${getOnlyDate(info.event.start)} ${getOnlyTime(
              info.event.start
            )}`,
            end: `${getOnlyDate(info.event.end)} ${getOnlyTime(
              info.event.end
            )}`,
            from_support: true,
          };
          info.event.extendedProps.taskInfo.start = taskInfo.start;
          info.event.extendedProps.taskInfo.end = taskInfo.end;
          updateTask(info.event.id, taskInfo);
        }
      };

      const validateDayLocked = (day) => {
        let dayLocked = this.dayAreLocked(day);
        if (dayLocked) {
          this.$toast.add({
            severity: "error",
            summary: "O dia está fechado",
            detail: "Não é permitida esta ação",
            life: 3000,
          });
        }
        return dayLocked;
      };
      const handleResourceChangeWrapper = (info) => {
        this.handleResourceChange(info);
      };

      this.calendarOptions.eventDrop = function (info) {
        // Check if resource changed (user reassignment)
        if (info.oldResource && info.newResource && info.oldResource.id !== info.newResource.id) {
          // Handle resource change (will show confirmation dialog)
          handleResourceChangeWrapper(info);
          return;
        }

        // Handle time change only (existing logic)
        if (validateDayLocked(getOnlyDate(info.event.start))) {
          info.revert();
          return;
        }
        if (info.event.extendedProps.taskInfo.isBooking) {
          let bookingInfo = {
            date: getOnlyDate(info.event.start),
            start: getOnlyTime(info.event.start),
            end: getOnlyTime(info.event.end),
          };

          info.event.extendedProps.taskInfo.start = bookingInfo.start;
          info.event.extendedProps.taskInfo.end = bookingInfo.end;
          info.event.extendedProps.taskInfo.date = bookingInfo.date;
          updateBooking(info.event.extendedProps.taskInfo.id, bookingInfo);
        } else {
          let taskInfo = {
            type: info.event.extendedProps.taskInfo.typeId,
            pat_number: parseInt(info.event.extendedProps.taskInfo.pat_number),
            start: `${getOnlyDate(info.event.start)} ${getOnlyTime(
              info.event.start
            )}`,
            end: `${getOnlyDate(info.event.end)} ${getOnlyTime(
              info.event.end
            )}`,
            from_support: true,
          };
          info.event.extendedProps.taskInfo.start = taskInfo.start;
          info.event.extendedProps.taskInfo.end = taskInfo.end;
          updateTask(info.event.id, taskInfo);
        }
      };

      const addTask = (start, end, userId) =>
        this.createTask(start, end, userId);

      this.calendarOptions.select = function (info) {
        let userId;
        if (info.resource != undefined) {
          userId = info.resource.id;
        }
        addTask(info.start, info.end, userId);
      };

      const updateTaskForm = (taskId) => this.updateFromForm(taskId);
      this.calendarOptions.eventDidMount = function (eventInfo) {
        if (eventInfo.event.startEditable == false) {
          return;
        }
        eventInfo.el.id = eventInfo.event.id;
        eventInfo.el.ondblclick = function () {
          updateTaskForm(eventInfo.event.id);
        };
      };
    },
    async getInterventionTypes() {
      this.isLoading = true;
      try {
        const types = await interventionService.getInterventionTypes();
        this.interventionTypes = types || [];
      } catch (error) {
        console.error("Erro ao carregar tipos de intervenção:", error);
      } finally {
        this.isLoading = false;
        this.firstload = false;
      }
    },
    getInterventionTypeId(interventionName) {
      let type = this.interventionTypes.find(
        (x) => x.name === interventionName
      );

      if (type == undefined) {
        return 0;
      }
      return type.id;
    },
    getMultipleUsersTasks(dateStart, dateEnd, userIds) {
      this.isLoading = true;
      let userTasks = [];
      return taskService
        .getTaskAndBookingByUsers(dateStart, dateEnd, userIds)
        .then((data) => {
          if (!data) {
            this.isLoading = false;
            return [];
          }

          let mergedDays = [];

          userIds.forEach((userId) => {
            const days = data[userId] || [];
            mergedDays = mergedDays.concat(days);

            days.forEach((day) => {
              let isPast = isDateBeforeToday(day.day);
              if (isPast || !this.userPermissiondEdit()) {
                this.lockDay(day.day);
              }
              const userInfo = this.userTasksInCalendar[userId];
              if (!userInfo) return;

              const officeColor = userInfo.officeColor;

              if (day.isHoliday || day.inVacation || day.missed) {
                let backgroundTask = {
                  resourceId: userId,
                  resourceEditable: false,
                  editable: false,
                  start: `${day.day} 00:00`,
                  end: `${day.day} 23:59`,
                  isHoliday: false,
                  inVacation: false,
                  missed: false,
                  username: userInfo.username,
                  textColor: "#43464f",
                  technicianInitials: userInfo.technicianInitials,
                  userId: userId,
                };
                if (day.isHoliday) {
                  backgroundTask.display = "background";
                  backgroundTask.title = day.isHoliday;
                  backgroundTask.isHoliday = true;
                  backgroundTask.color = hexToRGB("#ff4910", 0.15);
                } else if (day.inVacation) {
                  backgroundTask.allDay = true;
                  backgroundTask.title = "Férias";
                  backgroundTask.inVacation = true;
                  backgroundTask.color = isPast
                    ? hexToRGB(officeColor, 0.4)
                    : officeColor;
                  backgroundTask.editable = false;
                } else if (day.missed) {
                  backgroundTask.allDay = true;
                  backgroundTask.title = day.missed;
                  backgroundTask.missed = true;
                  backgroundTask.color = isPast
                    ? hexToRGB(officeColor, 0.4)
                    : officeColor;
                  backgroundTask.editable = false;
                }
                userTasks.push(backgroundTask);
              }

              day.tasks.forEach((task) => {
                if (this.taskTypes.interventions && task.isBooking != undefined) {
                  return;
                } else if (
                  task.isBooking != undefined &&
                  task.isBooking == true
                ) {
                  if (this.taskTypes.schedules && task.type == 2) {
                    return;
                  }
                  if (this.taskTypes.unavailable && task.type == 1) {
                    return;
                  }
                } else if (
                  (this.taskTypes.unavailable || this.taskTypes.schedules) &&
                  task.isBooking == undefined
                ) {
                  return;
                }
                task.typeId = this.getInterventionTypeId(task.type);
                let color = officeColor;

                if (this.taskColor.task === true) {
                  color = task.color;
                } else if (this.taskColor.user === true) {
                  color = userInfo.userColor;
                }

                if (task.marcada) {
                  color =
                    this.userTasksInCalendar[this.loggedUser.id]
                      .interventionConfirmedColor;
                }

                let colorFormatted =
                  task.isBooking != undefined && task.isBooking && task.type == 2
                    ? hexToRGB(color, 0.4)
                    : color;

                let userTaskFormatted = {
                  resourceId: userId,
                  resourceEditable: this.isDragDropUserEnabled() && !isPast && this.isEditable(task) && !(task.isBooking != undefined && task.isBooking == true),
                  id:
                    task.isBooking != undefined && task.isBooking == true
                      ? `booking-${task.id}`
                      : task.id,
                  title:
                    task.isBooking != undefined && task.isBooking == true
                      ? task.type == 1
                        ? `Reservado`
                        : `Indisponível`
                      : `${task.pat_number} - ${task.pat_title}`,
                  start:
                    task.isBooking != undefined && task.isBooking == true
                      ? `${task.date} ${task.start}`
                      : task.start,
                  end:
                    task.isBooking != undefined && task.isBooking == true
                      ? `${task.date} ${task.end}`
                      : task.end,
                  color: colorFormatted,
                  textColor: this.getReadableTextColor(colorFormatted),
                  editable: this.isEditable(task) && !isPast,
                  canDelete: isPast ? false : this.canDelete(task),
                  canEditTask: this.userPermissiondEdit() && !isPast,
                  taskInfo: task,
                  userId: userId,
                  username: userInfo.username,
                  technicianInitials: userInfo.technicianInitials,
                };
                userTasks.push(userTaskFormatted);
              });
            });
          });

          this.tasksInCalendar = mergedDays;
          this.isLoading = false;
          return userTasks;
        })
        .catch((error) => {
          this.isLoading = false;
          console.error("Erro ao carregar tarefas dos utilizadores:", error);
          return [];
        });
    },
    updateTask(taskId, taskNewInfo) {
      return taskService.updatedTask(taskId, taskNewInfo).then((response) => {
        if (!response) {
          return this.$toast.add({
            severity: "error",
            summary: "Erro ao gravar",
            detail: "Ocorreu um erro ao gravar a tarefa",
            life: 3000,
          });
        }
        return this.$toast.add({
          severity: "success",
          summary: "Atualizado com sucesso",
          detail: "A tarefa foi atualizada com sucesso",
          life: 3000,
        });
      });
    },
    deleteTask(itemId) {
      let item = this.calendarApi.getEventById(itemId);
      let itemInfo = item._def.extendedProps.taskInfo;
      this.$confirm.require({
        message: `Tem a certeza que deseja eliminar esta ${
          itemInfo.isBooking != undefined && itemInfo.isBooking
            ? itemInfo.type == 1
              ? "reserva"
              : "indisponíbilidade"
            : "tarefa"
        }?`,
        icon: "pi pi-exclamation-triangle",
        position: "top",
        accept: () => {
          if (itemInfo.isBooking != undefined && itemInfo.isBooking) {
            return bookingService
              .removeBooking(itemInfo.id)
              .then((response) => {
                if (!response) {
                  return this.$toast.add({
                    severity: "error",
                    summary: `Erro ao eliminar a ${
                      itemInfo.type == 1 ? "reserva" : "indisponíbilidade"
                    }`,
                    detail: `Ocorreu um erro ao eliminar a ${
                      itemInfo.type == 1 ? "reserva" : "indisponíbilidade"
                    }`,
                    life: 3000,
                  });
                }
                item.remove();
                this.$toast.add({
                  severity: "success",
                  summary: `${
                    itemInfo.type == 1 ? "Reserva" : "Indisponíbilidade"
                  } eliminada com sucesso`,
                  detail: "",
                  life: 3000,
                });
              });
          } else {
            let typeId = itemInfo.typeId;

            return taskService.removeTask(itemId, typeId).then((response) => {
              if (!response) {
                this.$toast.add({
                  severity: "error",
                  summary: "Erro ao eliminar a tarefa",
                  detail: "Ocorreu um erro ao eliminar a tarefa",
                  life: 3000,
                });
              }
              item.remove();
              this.$toast.add({
                severity: "success",
                summary: "Tarefa eliminada com sucesso",
                detail: "",
                life: 3000,
              });
            });
          }
        },
      });
    },
    createTask(start, end, userId) {
      this.calendarApi.unselect();
      let startDay = getOnlyDate(start);

      if (!this.userPermissiondEdit()) {
        return this.$toast.add({
          severity: "error",
          summary: "Sem permissão",
          detail: "Não tem permissão para criar tarefas de suporte",
          life: 3000,
        });
      }

      if (this.dayAreLocked(startDay)) {
        return this.$toast.add({
          severity: "error",
          summary: "Dia fechado",
          detail: "Não é possível a criação da tarefa",
          life: 3000,
        });
      }
      let endDay = getOnlyDate(end);

      if (startDay !== endDay) {
        return this.$toast.add({
          severity: "error",
          summary: "Data inválida",
          detail: "O dia de ínicio é diferente do dia de fim da tarefa",
          life: 3000,
        });
      }

      this.userTask = new Task();
      this.userTask.action = "create";
      this.userTask.day = startDay;
      this.userTask.start = start;
      this.userTask.end = end;
      this.userTask.isBooking = false;
      this.userTask.type = null;
      this.userTask.taskType = 0;
      if (userId != undefined) {
        this.userTask.usersSelecteds = [
          {
            id: this.userTasksInCalendar[userId].userId,
            username: this.userTasksInCalendar[userId].username,
            office: this.userTasksInCalendar[userId].userOffice,
            technicianInitials:
              this.userTasksInCalendar[userId].technicianInitials,
            officeColor: this.userTasksInCalendar[userId].officeColor,
            userColor: this.userTasksInCalendar[userId].userColor,
          },
        ];
      }
      this.showTaskForm = true;
    },
    async taskFormSubmited(task) {
      this.isLoading = true;

      try {
        if (task.day instanceof Date) {
          task.day = getOnlyDate(task.day);
        }
        if (task.start instanceof Date) {
          task.start = getOnlyTime(task.start);
        }
        if (task.end instanceof Date) {
          task.end = getOnlyTime(task.end);
        }

        let submissionPromise;

        if (task.isBooking != undefined && task.isBooking == true) {
          //IS BOOKING
          let bookingInfo = {
            date: task.day,
            start: task.start,
            end: task.end,
            resume: task.resume != null ? task.resume : "",
            usersSelecteds: task.usersSelecteds,
            note: task.note != null ? task.note : "",
            type: task.type != null ? task.type : 0,
          };

          if (
            task.oldUser != undefined &&
            task.oldUser != task.usersSelecteds
          ) {
            bookingInfo["new_user"] = task.usersSelecteds;
          }

          if (task.bookingId == undefined) {
            submissionPromise = this.addBooking(bookingInfo);
          } else {
            submissionPromise = this.updateBooking(
              task.bookingId,
              bookingInfo,
              true
            );
          }
        } else if (
          task.isBooking != undefined &&
          task.isBooking == false &&
          task.bookingId != undefined
        ) {
          let taskInfo = {
            type: task.type,
            pat_number: task.patNumber,
            start: `${task.day} ${task.start}`,
            end: `${task.day} ${task.end}`,
            resume: task.resume,
            user_id: task.usersSelecteds,
            note: task.note,
            from_support: true,
            marcada: task.marcada,
            notify_sms_confirmation: task.notify_sms_confirmation,
            notify_sms_phone: task.notify_sms_phone,
            save_notes_to_pat_solution: task.save_notes_to_pat_solution,
          };

          taskInfo.pat_numbers = Array.isArray(task.selectedPats)
            ? task.selectedPats.map((p) =>
                typeof p === "object" ? p.patNumber : p
              )
            : [];

          if (
            task.oldUser != undefined &&
            task.oldUser != task.usersSelecteds
          ) {
            taskInfo["new_user"] = task.usersSelecteds;
          }

          //convert booking to task
          submissionPromise = this.createTaskFromBooking(
            task.bookingId,
            taskInfo
          );
        } else {
          //Is Task
          let taskInfo = {
            type: task.type,
            pat_number: task.patNumber,
            start: `${task.day} ${task.start}`,
            end: `${task.day} ${task.end}`,
            resume: task.resume != undefined ? task.resume : "",
            usersSelecteds: task.usersSelecteds,
            note: task.note != undefined ? task.note : "",
            from_support: true,
            marcada: task.marcada,
            notify_sms_confirmation: task.notify_sms_confirmation,
            notify_sms_phone: task.notify_sms_phone,
            save_notes_to_pat_solution: task.save_notes_to_pat_solution,
          };

          if (Object.keys(task).includes("proceed_action")) {
            taskInfo["proceed_action"] = true;
          }

          taskInfo.pat_numbers = Array.isArray(task.selectedPats)
            ? task.selectedPats.map((p) =>
                typeof p === "object" ? p.patNumber : p
              )
            : [];

          if (
            task.oldUser != undefined &&
            task.oldUser != task.usersSelecteds
          ) {
            taskInfo["new_user"] = task.usersSelecteds;
          }
          switch (task.action) {
            case "update":
              submissionPromise = this.updateFormSubmited(
                task.taskId,
                taskInfo
              );
              break;
            default:
              submissionPromise = this.saveNewTask(taskInfo);
          }
        }

        await submissionPromise;

        this.userTasks = null;
        this.showTaskForm = false;
      } catch (error) {
        if (error && error.toast) {
          if (error.response && error.response.ask_to_proceed) {
            this.$set(task, "proceed_action", true);
            return this.confirmTaskDuplicatedPat(
              error.response.message,
              task,
              error.response.pat_number
            );
          }

          this.$toast.add({
            severity: "error",
            summary: error.toast.summary,
            detail: error.toast.detail,
            life: 4000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Erro Inesperado",
            detail: "Ocorreu um erro que não era esperado. Tente novamente.",
            life: 4000,
          });
          console.error("Erro:", error);
        }
      } finally {
        this.isLoading = false;
      }
    },
    taskFormCanceled() {
      this.userTasks = null;
      this.showTaskForm = false;
    },
    async saveNewTask(task) {
      const createNewTask = (user, task) => {
        return taskService
          .createTask(task)
          .then((response) => {
            if (response) {
              if (response.status == 409) {
                return response;
              }
              if (
                this.userTasksInCalendar[user.id] != undefined &&
                this.userTasksInCalendar[user.id].inCalendar == true
              ) {
                response.typeId = this.getInterventionTypeId(response.type);

                let eventColor = this.userTasksInCalendar[user.id].officeColor;
                if (task.marcada) {
                  eventColor =
                    this.userTasksInCalendar[this.loggedUser.id]
                      .interventionConfirmedColor;
                }

                this.calendarApi.addEvent({
                  resourceId: user.id,
                  resourceEditable: this.isDragDropUserEnabled() && this.isEditable(response),
                  id: response.id,
                  title: `${response.pat_number} - ${response.pat_title}`,
                  start: response.start,
                  end: response.end,
                  editable: this.isEditable(response),
                  canDelete: this.canDelete(response),
                  canEditTask: this.userPermissiondEdit(),
                  color: eventColor,
                  textColor: this.getReadableTextColor(eventColor),
                  taskInfo: response,
                  userId: task.user_id,
                  username: this.userTasksInCalendar[task.user_id].username,
                  marcada: task.marcada,
                });
              }
              return true;
            }

            return false;
          })
          .then((response) => {
            if (!response) {
              const error = new Error("Erro ao gravar a tarefa");
              error.toast = {
                summary: "Erro ao gravar",
                detail: `Ocorreu um erro ao gravar a tarefa`,
              };

              throw error;
            }

            if (response.status != undefined && response.status == 409) {
              const error = new Error("Erro ao gravar a tarefa");
              error.toast = {
                summary: `Dia fechado`,
                detail: `O ${user.username} tem o dia fechado. Tarefa não criada`,
              };

              error.response = response.data;

              throw error;
            }

            this.$toast.add({
              severity: "success",
              summary: `Tarefa criada`,
              detail: `Tarefa criada com sucesso para o ${user.username}`,
              life: 3000,
            });
          });
      };
      const patNumbers = Array.from(task.pat_numbers);

      for (const patNumber of patNumbers) {
        for (const userSelect of task.usersSelecteds) {
          const newTask = {
            ...task,
            user_id: userSelect.id,
            pat_number: patNumber,
          };
          delete newTask.pat_numbers;

          await createNewTask(userSelect, newTask);
        }
      }
    },
    updateFromForm(taskId) {
      let task = this.calendarApi.getEventById(taskId);
      let taskInfo = task._def.extendedProps.taskInfo;
      this.userTask = new Task();

      if (taskInfo.isBooking != undefined && taskInfo.isBooking == true) {
        this.userTask.isBooking = true;
        this.userTask.type = taskInfo.type;
        this.userTask.bookingId = taskInfo.id;
        this.userTask.day = taskInfo.date;
        this.userTask.start = new Date(`${taskInfo.date} ${taskInfo.start}`);
        this.userTask.end = new Date(`${taskInfo.date} ${taskInfo.end}`);
        this.userTask.type = taskInfo.type;
        this.userTask.taskType = taskInfo.type;
      } else {
        taskInfo.start = new Date(taskInfo.start);
        taskInfo.end = new Date(taskInfo.end);
        this.userTask.start = taskInfo.start;
        this.userTask.end = taskInfo.end;
        this.userTask.day = getOnlyDate(taskInfo.start);
        this.userTask.isBooking = false;
        this.userTask.localization = taskInfo.localization;
        this.userTask.type = taskInfo.typeId = !undefined ? taskInfo.typeId : 0;
        this.userTask.taskType = 0;
      }

      if (this.dayAreLocked(this.userTask.day) || !this.userPermissiondEdit()) {
        this.userTask.action = "view";
      } else if (
        taskInfo.created_by != this.loggedUser.username &&
        !this.can("supportEditTasks")
      ) {
        this.userTask.action = "view";
      } else {
        this.userTask.action = "update";
      }
      this.userTask.action =
        this.dayAreLocked(this.userTask.day) || !this.userPermissiondEdit()
          ? "view"
          : "update";
      this.userTask.resume = taskInfo.resume;
      this.userTask.patNumber = taskInfo.pat_number;
      this.userTask.taskId = taskId;
      this.userTask.color = taskInfo.color;
      this.userTask.technician = taskInfo.technician;
      this.userTask.created_by = taskInfo.created_by;
      this.userTask.created_at = `dia ${getOnlyDate(
        new Date(taskInfo.created_at)
      )} às ${getOnlyTime(new Date(taskInfo.created_at))}`;
      this.userTask.updated_by = taskInfo.updated_by;
      this.userTask.updated_at = `dia ${getOnlyDate(
        new Date(taskInfo.updated_at)
      )} às ${getOnlyTime(new Date(taskInfo.updated_at))}`;
      this.userTask.note = taskInfo.note;
      this.userTask.usersSelecteds = parseInt(task._def.extendedProps.userId);
      this.userTask.oldUser = parseInt(task._def.extendedProps.userId);
      this.userTask.task_all_info = taskInfo;
      this.userTask.marcada = taskInfo.marcada;

      this.showTaskForm = true;
    },
    updateFormSubmited(taskId, taskNewInfo) {
      return taskService.updatedTask(taskId, taskNewInfo).then((response) => {
        if (!response) {
          const error = new Error("Erro ao gravar a tarefa");
          error.toast = {
            summary: "Erro ao gravar",
            detail: `Ocorreu um erro ao atualizar a tarefa`,
          };

          throw error;
        }

        this.refetchEvents();
        return this.$toast.add({
          severity: "success",
          summary: "Tarefa atualizada com sucesso",
          detail: "",
          life: 3000,
        });
      });
    },
    lockDay(day) {
      let dateHeader = document.querySelector(`[data-date="${day}"]`);
      if (dateHeader) {
        let icone = dateHeader.querySelector("i");
        if (icone) {
          icone.classList.remove("pi-lock-open");
          icone.classList.add("pi-lock");
        }
      }
    },
    dayAreLocked(day) {
      if (day instanceof Date) {
        day = getOnlyDate(day);
      }
      return isDateBeforeToday(day);
    },
    permissionUnLocked(day) {
      //Case loged user is ESA
      if (this.$store.state.auth.user.isEsa) {
        return true;
      }

      if (!this.getSelectedUser().permissionChangeMe) {
        return false;
      }

      let dayAux = this.tasksInCalendar.find((x) => x.day === day);
      if (dayAux.currentStatus === undefined && dayAux.locked) {
        return false;
      }
      return true;
    },
    forbiddenToast() {
      return this.$toast.add({
        severity: "error",
        summary: "Não autorizado",
        detail: "Não tem permissão para efetuar esta ação",
        life: 3000,
      });
    },
    goDate(date) {
      this.calendarApi.gotoDate(date.id);
      this.calendarGoTo = false;
    },
    removeAllTasks() {
      if (!this.calendarApi) {
        return;
      }
      let events = this.calendarApi.getEvents();
      events.forEach((event) => {
        event.remove();
      });
    },
    onNodeSelect(node) {
      localStorage.selectedNodes = JSON.stringify(this.selectedNodes);
      if (node.data == "office") {
        this.$store.state.auth.user.supportUsers[node.key].forEach((user) => {
          if (this.userTasksInCalendar[user.id] == undefined) {
            this.userTasksInCalendar[user.id] = {
              inCalendar: true,
              userId: user.id,
              userColor: user.userColor,
              officeColor: user.officeColor,
              username: user.username,
              userOffice: user.office,
              technicianInitials: user.technicianInitials,
            };
          } else {
            this.userTasksInCalendar[user.id].inCalendar = true;
          }
        });
      } else {
        if (this.userTasksInCalendar[node.key] == undefined) {
          this.userTasksInCalendar[node.key] = {
            inCalendar: true,
            userId: node.key,
            userColor: node.userColor,
            officeColor: node.officeColor,
            username: node.label,
            technicianInitials: node.technicianInitials,
          };
        } else {
          this.userTasksInCalendar[node.key].inCalendar = true;
        }
      }
      this.calendarApi.refetchResources();
      this.refetchEvents();
    },
    onNodeUnselect(node) {
      localStorage.selectedNodes = JSON.stringify(this.selectedNodes);
      if (node.data == "office") {
        this.$store.state.auth.user.supportUsers[node.key].forEach((user) => {
          if (this.userTasksInCalendar[user.id] != undefined) {
            this.userTasksInCalendar[user.id].inCalendar = false;
          }
        });
      } else {
        if (this.userTasksInCalendar[node.key] != undefined) {
          this.userTasksInCalendar[node.key].inCalendar = false;
        }
      }
      this.calendarApi.refetchResources();
      this.refetchEvents();
    },
    async updateBooking(bookingId, bookingNewInfo, fromForm) {
      const response = await bookingService.updatedBooking(
        bookingId,
        bookingNewInfo
      );

      if (!response) {
        const error = new Error("Erro ao gravar a tarefa");
        error.toast = {
          summary: "Erro ao gravar",
          detail: "Ocorreu um erro ao gravar a reserva",
        };

        throw error;
      }

      if (fromForm != undefined && fromForm == true) {
        let booking = this.calendarApi.getEventById(`booking-${bookingId}`);
        booking.remove();

        let eventColor =
          response.type == 2
            ? hexToRGB(
                this.userTasksInCalendar[bookingNewInfo.usersSelecteds]
                  .officeColor,
                0.4
              )
            : this.userTasksInCalendar[bookingNewInfo.usersSelecteds]
                .officeColor;

        this.calendarApi.addEvent({
          resourceId: bookingNewInfo.usersSelecteds,
          resourceEditable: false,
          id: `booking-${response.id}`,
          title: response.type == 1 ? `Reservado` : `Indisponível`,
          start: `${response.date} ${response.start}`,
          end: `${response.date} ${response.end}`,
          editable: this.isEditable(response),
          canDelete: this.canDelete(response),
          canEditTask: this.userPermissiondEdit(),
          color: eventColor,
          textColor: this.getReadableTextColor(eventColor),
          taskInfo: response,
          userId: bookingNewInfo.usersSelecteds,
          username:
            this.userTasksInCalendar[bookingNewInfo.usersSelecteds].username,
        });
      }

      this.$toast.add({
        severity: "success",
        summary: "Atualizado com sucesso",
        detail: "A reserva foi atualizada com sucesso",
        life: 3000,
      });
    },
    async addBooking(booking) {
      for (const user of booking.usersSelecteds) {
        booking.user_id = user.id;
        const response = await bookingService.createBooking(booking);

        if (!response) {
          const error = new Error("Erro ao gravar a reserva");
          error.toast = {
            summary: "Erro ao gravar",
            detail: `Ocorreu um erro ao gravar a ${
              booking.type == 1 ? "reserva" : "indisponibilidade"
            }`,
            life: 3000,
          };

          throw error;
        }

        if (
          this.userTasksInCalendar[user.id] != undefined &&
          this.userTasksInCalendar[user.id].inCalendar == true
        ) {
          response.typeId = this.getInterventionTypeId(response.type);

          let eventColor =
            response.type == 2
              ? hexToRGB(this.userTasksInCalendar[user.id].officeColor, 0.4)
              : this.userTasksInCalendar[user.id].officeColor;

          this.calendarApi.addEvent({
            resourceId: user.id,
            resourceEditable: false,
            id: `booking-${response.id}`,
            title: response.type == 1 ? `Reservado` : `Indisponível`,
            type: response.type,
            start: `${response.date} ${response.start}`,
            end: `${response.date} ${response.end}`,
            color: eventColor,
            textColor: this.getReadableTextColor(eventColor),
            editable: this.isEditable(response),
            canDelete: this.canDelete(response),
            canEditTask: this.userPermissiondEdit(),
            taskInfo: response,
            userId: booking.user_id,
            username: this.userTasksInCalendar[booking.user_id].username,
          });
        }

        this.$toast.add({
          severity: "success",
          summary: `${
            booking.type == 1 ? "Reserva" : "Indisponibilidade"
          } criada com sucesso`,
          detail: "",
          life: 3000,
        });
      }
    },
    async createTaskFromBooking(bookingId, task) {
      const saveTaskFromBooking = async (task) => {
        try {
          const response = await taskService.createTask(task);

          if (!response) {
            const error = new Error("Erro ao gravar");
            error.toast = {
              summary: "Erro ao gravar",
              detail: "Ocorreu um erro ao gravar a tarefa",
            };

            throw error;
          }

          if (
            Object.keys(response).includes("statusText") &&
            response.status != 200
          ) {
            if (response.status == 409) {
              const error = new Error("Erro ao gravar a tarefa");
              error.toast = {
                summary: `Dia fechado`,
                detail: `O(s) utilizador(es) tem o dia fechado. Tarefa não criada`,
              };

              error.response = response.data;

              throw error;
            }

            const error = new Error("Erro ao gravar");
            error.toast = {
              summary: "Erro ao gravar",
              detail: "Ocorreu um erro ao gravar a tarefa",
            };

            throw error;
          }

          let booking = this.calendarApi.getEventById(`booking-${bookingId}`);
          if (booking) {
            booking.remove();
          }

          if (
            this.userTasksInCalendar[task.user_id] != undefined &&
            this.userTasksInCalendar[task.user_id].inCalendar == true
          ) {
            response.typeId = this.getInterventionTypeId(response.type);
            let eventColor = this.userTasksInCalendar[task.user_id].officeColor;

            if (task.marcada) {
              eventColor =
                this.userTasksInCalendar[this.loggedUser.id]
                  .interventionConfirmedColor;
            }

            this.calendarApi.addEvent({
              resourceId: task.user_id,
              resourceEditable: this.isDragDropUserEnabled() && this.isEditable(response),
              id: response.id,
              title: `${response.pat_number} - ${response.pat_title}`,
              start: response.start,
              end: response.end,
              color: eventColor,
              textColor: this.getReadableTextColor(eventColor),
              editable: this.isEditable(response),
              canDelete: this.canDelete(response),
              canEditTask: this.userPermissiondEdit(),
              taskInfo: response,
              userId: task.user_id,
              username: this.userTasksInCalendar[task.user_id].username,
            });
          }

          bookingService.updatedBooking(bookingId, {
            intervention_id: response.id,
          });

          this.$toast.add({
            severity: "success",
            summary: "Tarefa criada com sucesso",
            detail: "",
            life: 3000,
          });
        } catch (err) {
          if (err.toast) {
            throw err;
          }

          console.log("Erro inesperado em saveTaskFromBooking:", err);
          const error = new Error("Erro ao gravar");
          error.toast = {
            severity: "error",
            summary: "Erro ao gravar",
            detail: err.message || "Ocorreu um erro ao gravar a tarefa",
            life: 3000,
          };
          throw error;
        }
      };

      const patNumbers = Array.from(task.pat_numbers);

      for (const patNumber of patNumbers) {
        const newTask = {
          ...task,
          user_id: task.user_id,
          pat_number: patNumber,
        };

        await saveTaskFromBooking(newTask);
      }
    },
    userPermissiondEdit() {
      if (this.$store.state.auth.user.isEsa) {
        return true;
      }

      if (this.can("supportEditTasks")) {
        return true;
      }

      if (
        this.$store.state.auth.user.department == "Tecnico" ||
        this.$store.state.auth.user.department == "Tecnico - Admin"
      ) {
        return true;
      }

      return false;
    },
    goToMap(date) {
      let route = this.$router.resolve({
        path: `/support/map/${getOnlyDate(date)}`,
      });
      window.open(route.href, "_blank");
    },
    async getResources() {
      const setResource = (userInfo, officeInfo) => {
        return new Promise((resolve) =>
          resolve({
            id: userInfo.key,
            office: officeInfo.label,
            title: userInfo.label,
            officeColor: userInfo.officeColor,
            userColor: userInfo.userColor,
            technicianInitials: userInfo.technicianInitials,
          })
        );
      };
      let resouces = [];
      for (const office of this.nodes) {
        for (const officeUser of office.tree.children) {
          if (this.userTasksInCalendar[officeUser.key].inCalendar) {
            resouces.push(await setResource(officeUser, office.tree));
          }
        }
      }

      return resouces;
    },
    taskColorChange(by) {
      const colorConfig = {
        task: { office: false, task: true, user: false },
        user: { office: false, task: false, user: true },
        office: { office: true, task: false, user: false },
      };

      this.taskColor = colorConfig[by] || colorConfig["office"];
      localStorage.supportColorsBy = JSON.stringify(this.taskColor);
      this.refetchEvents();
    },
    taskTypeChange(by) {
      const typeConfigs = {
        unavailable: {
          all: false,
          interventions: false,
          schedules: false,
          unavailable: true,
        },
        schedules: {
          all: false,
          interventions: false,
          schedules: true,
          unavailable: false,
        },
        interventions: {
          all: false,
          interventions: true,
          schedules: false,
          unavailable: false,
        },
        all: {
          all: true,
          interventions: false,
          schedules: false,
          unavailable: false,
        },
      };
      this.taskTypes = typeConfigs[by] || typeConfigs["all"];
      this.refetchEvents();
    },
    isEditable(task) {
      if (this.loggedUser.isEsa) {
        return true;
      }
      //Caso de indisponibilidade
      if (
        task.isBooking != undefined &&
        task.isBooking == true &&
        task.type == 2
      ) {
        if (this.can("editUnavailability")) {
          return true;
        }
        return false;
      }
      if (
        task.created_by != this.loggedUser.username &&
        !this.userPermissiondEdit()
      ) {
        return false;
      }
      return true;
    },
    canDelete(task) {
      if (this.loggedUser.isEsa) {
        return true;
      }
      //Caso de indisponibilidade
      if (
        task.isBooking != undefined &&
        task.isBooking == true &&
        task.type == 2
      ) {
        if (this.can("deleteUnavailability")) {
          return true;
        }
        return false;
      }
      if (task.created_by == this.loggedUser.username) {
        return true;
      }
      if (this.can("deleteTasks")) {
        return true;
      }
      return false;
    },
    cloneTask(taskId) {
      let task = this.calendarApi.getEventById(taskId);
      let taskInfo = task._def.extendedProps.taskInfo;

      let info = {
        start: taskInfo.start,
        end: taskInfo.end,
        resume: taskInfo.resume,
        note: taskInfo.note,
        usersSelecteds: [{ id: parseInt(task._def.extendedProps.userId) }],
      };
      if (taskInfo.type === 1 || taskInfo.type === 2) {
        //booking or unavaliable
        info.date = taskInfo.date;
        info.type = parseInt(taskInfo.type);
        return this.addBooking(info);
      } else {
        //task
        info.pat_number = parseInt(taskInfo.pat_number);
        info.pat_numbers = [parseInt(taskInfo.pat_number)];
        info.type = taskInfo.typeId;
        info.from_support = true;
        info.proceed_action = true;
        return this.saveNewTask(info);
      }
    },
    menuClick(item) {
      const menuConfig = {
        technicians: { technicians: true, colors: false, whatToSee: false },
        colors: { technicians: false, colors: true, whatToSee: false },
        whatToSee: { technicians: false, colors: false, whatToSee: true },
        seeAll: { technicians: true, colors: true, whatToSee: true },
        hideAll: { technicians: false, colors: false, whatToSee: false },
      };

      if (menuConfig[item]) {
        this.menuConfig = menuConfig[item];
        this.scheduleCalendarResize();
      } else {
        console.error(`Item de menu desconhecido: ${item}`);
      }
    },
    getReadableTextColor(backgroundColor) {
      const whiteContrast = chroma.contrast(backgroundColor, "#ffffff");
      const blackContrast = chroma.contrast(backgroundColor, "#000000");
      return whiteContrast > blackContrast ? "#ffffff" : "#000000";
    },
    isDragDropUserEnabled() {
      // Check if current view is resourceTimeGridDay (Dia)
      if (!this.calendarApi) {
        return false;
      }
      const currentView = this.calendarApi.view.type;
      if (currentView !== 'resourceTimeGridDay') {
        return false;
      }
      // Check if user has permission to edit tasks
      return this.userPermissiondEdit();
    },
    confirmUserReassignment(message, taskInfo, oldUser, newUser, onAccept, onReject) {
      this.$confirm.require({
        message: message,
        header: `Reatribuir tarefa para ${newUser.username}?`,
        acceptLabel: "Sim, reatribuir",
        rejectLabel: "Não, cancelar",
        icon: "pi pi-exclamation-triangle",
        accept: async () => {
          await onAccept();
        },
        reject: () => {
          onReject();
          this.$toast.add({
            severity: "warn",
            summary: "Cancelado!",
            detail: "Reatribuição de tarefa cancelada",
            life: 3000,
          });
        },
      });
    },
    async handleResourceChange(info) {
      const event = info.event;
      const oldResourceId = info.oldResource ? info.oldResource.id : null;
      const newResourceId = info.newResource ? info.newResource.id : null;

      // Validate resource change occurred
      if (!oldResourceId || !newResourceId || oldResourceId === newResourceId) {
        return;
      }

      // Validate drag and drop user reattribution is enabled for the current view
      if (!this.isDragDropUserEnabled()) {
        info.revert();
        return;
      }

      const taskInfo = event.extendedProps.taskInfo;

      // Validate not a booking - bookings cannot be reassigned
      if (taskInfo.isBooking) {
        info.revert();
        this.$toast.add({
          severity: "error",
          summary: "Não é possível reatribuir",
          detail: "Reservas e indisponibilidades não podem ser reatribuídas entre utilizadores",
          life: 4000,
        });
        return;
      }

      // Validate day is not locked
      const targetDay = getOnlyDate(event.start);
      if (this.dayAreLocked(targetDay)) {
        info.revert();
        this.$toast.add({
          severity: "error",
          summary: "Dia bloqueado",
          detail: "Não é possível reatribuir tarefas para dias bloqueados",
          life: 3000,
        });
        return;
      }

      // Validate user has permission
      if (!this.userPermissiondEdit()) {
        info.revert();
        this.forbiddenToast();
        return;
      }

      // Get old and new user info
      const oldUser = this.userTasksInCalendar[oldResourceId];
      const newUser = this.userTasksInCalendar[newResourceId];

      if (!oldUser || !newUser) {
        info.revert();
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: "Utilizador não encontrado",
          life: 3000,
        });
        return;
      }

      // Prepare confirmation message
      const message = `Deseja reatribuir a tarefa PAT ${taskInfo.pat_number} de ${oldUser.username} para ${newUser.username}?`;

      // Show confirmation dialog
      this.confirmUserReassignment(
        message,
        taskInfo,
        oldUser,
        newUser,
        async () => {
          // On accept - update task
          try {
            const updatedTaskInfo = {
              type: taskInfo.typeId,
              pat_number: parseInt(taskInfo.pat_number),
              start: `${getOnlyDate(event.start)} ${getOnlyTime(event.start)}`,
              end: `${getOnlyDate(event.end)} ${getOnlyTime(event.end)}`,
              from_support: true,
              new_user: parseInt(newResourceId),
            };

            await taskService.updatedTask(event.id, updatedTaskInfo);

            // Update event properties with new user info
            event.setProp('title', `${taskInfo.pat_number} - ${taskInfo.pat_title}`);
            event.setExtendedProp('userId', newResourceId);
            event.setExtendedProp('username', newUser.username);
            event.setExtendedProp('taskInfo', {
              ...taskInfo,
              user_id: newResourceId,
            });

            // Update color if needed
            let eventColor = newUser.officeColor;
            if (taskInfo.marcada) {
              eventColor = this.userTasksInCalendar[this.loggedUser.id].interventionConfirmedColor;
            }
            event.setProp('color', eventColor);
            event.setProp('textColor', this.getReadableTextColor(eventColor));

            this.$toast.add({
              severity: "success",
              summary: "Tarefa reatribuída",
              detail: `Tarefa reatribuída para ${newUser.username} com sucesso`,
              life: 3000,
            });
          } catch (error) {
            info.revert();
            this.$toast.add({
              severity: "error",
              summary: "Erro ao reatribuir",
              detail: "Ocorreu um erro ao reatribuir a tarefa. Tente novamente.",
              life: 4000,
            });
          }
        },
        () => {
          // On reject - revert the drag
          info.revert();
        }
      );
    },
  },
};
</script>

<style>
.f-event-main {
  background: rgba(255, 255, 255, 0) !important;
  background-color: rgba(255, 255, 255, 0) !important;
  border: 0px !important;
  overflow: hidden;
}

.fc-event-title {
  font-weight: bold !important;
}

.position-fixed {
  position: fixed;
}

.fc .fc-view-harness td {
  background: rgba(0, 0, 0, 0);
}
.pi-chevron-down::before {
  color: #6c757d !important;
}

.p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight {
  background: #fff;
  color: #000;
}

.p-tree-container .pi-check:before {
  color: black;
}
.p-tree-container .pi-user:before {
  color: #6c757d;
}
.p-tree-container .pi-home:before {
  color: #6c757d;
}
.p-tree-container .pi-chevron-right:before {
  color: #6c757d;
}
.p-tooltip {
  z-index: 99;
}
.p-tooltip-text {
  background-color: #fff !important;
  color: #000 !important;
  border-style: solid !important;
  border-width: 1px !important;
  border-color: #000 !important;
}
.cursor-grab {
  cursor: grab;
}

.fc-timeGridWeek-button {
  background-color: #007bff !important;
  border-color: #007bff !important;
}

.fc-button-active {
  background-color: #97c1fe !important;
  border-color: #97c1fe !important;
}

.slotLaneStriped {
  background-color: rgba(239, 239, 239, 0.25) !important;
}

.tree-border-color {
  border-bottom-width: 2px;
  border-bottom-style: solid;
}
.square {
  display: inline-flex;
  width: 10px !important;
  height: 10px !important;
  margin-right: 5px;
  margin-top: 4px;
}

.fc-header-toolbar.fc-toolbar.fc-toolbar-ltr {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.calendar-fullscreen-wrapper {
  position: relative;
  background: #fff;
  transition: all 0.3s;
  overflow: hidden;
}

.calendar-fullscreen-wrapper.fullscreen {
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  background: #fff;
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
  flex-direction: column;
}

.calendar-fullscreen-wrapper.fullscreen .fc {
  height: 100% !important;
  min-height: 100% !important;
  padding: 5px;
}

.calendar-toolbar-fullscreen-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10001;
}
</style>
